import { queryOpenAI } from "./openAiService";
import websiteDataJSON from "../websiteData.json";

class ActionProvider {
  constructor(createChatBotMessage, setStateFunc) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;

    // Combine scraped data
    this.websiteData = Object.values(websiteDataJSON).join(" ");
    
    // Initialize conversation history with a revised system message:
    this.conversationHistory = [
      {
        role: "system",
        content: `
          You are a helpful AI assistant with expertise in energy management, chiller optimization, and sustainable building solutions.

          Your answers must be concise and written in plain text without any markdown formatting.
          Do not use any asterisks, underscores, hyphens, or any markdown symbols.
          Avoid formatting your response as a list; instead, provide a brief, summarized paragraph.
          Do not mention that the answer is "based on website data" or similar.
          Focus on explaining SquareCloud’s energy saving services, chiller optimization, and related topics in clear, direct language.

          Contextual data:
          ${this.websiteData}
        `
      }
    ];
  }

  handleUserMessage = async (userMessage) => {
    try {
      // 1. Add the user's message to conversation history
      this.conversationHistory.push({
        role: "user",
        content: userMessage
      });

      // 2. Send the entire conversation to OpenAI
      const openAiReply = await queryOpenAI(this.conversationHistory);

      // 3. Add the assistant's reply to conversation history
      this.conversationHistory.push({
        role: "assistant",
        content: openAiReply
      });

      // 4. Clean up any HTML tags (optional)
      const cleanResponse = openAiReply.replace(/<\/?[^>]+(>|$)/g, "");
      const botMessage = this.createChatBotMessage(cleanResponse);

      // 5. Update the chatbot state
      this.updateChatbotState(botMessage);
    } catch (error) {
      console.error("Error handling user message:", error);
      const errorMessage = this.createChatBotMessage(
        "Oops! I couldn't process that. Please try again."
      );
      this.updateChatbotState(errorMessage);
    }
  };

  updateChatbotState(message) {
    this.setState((prevState) => ({
      ...prevState,
      messages: [...prevState.messages, message]
    }));
  }
}

export default ActionProvider;
